





































import { Component, Prop, Vue } from "vue-property-decorator";
import { DateTime } from "luxon";

@Component({
  components: {
  },
})

export default class GuestReservationHistoryTableMobileTile extends Vue {
  @Prop() unit?: any;

  get reservationDateUI() {
    const arrivalDate = DateTime.fromISO(this.unit.arrivalDate);

    if(this.unit.arrivalDate !== undefined)
    {
      return arrivalDate.day + ". " + arrivalDate.month + ". - " 
        + this.$d(new Date(this.unit.departureDate));
    }
    else {
      return this.$d(new Date(this.unit.date));
    }
  }

  get currencyCodeUI() {
    return this.unit.currencyCode ?? "EUR";
  }
}

